<template>
<div>
  <div style="margin-bottom: 1rem; color: red">编制班级可以用顾客分组,比如大班,1班,2班</div>
  <el-form inline :model="searchForm" :loading="searching">
    <el-form-item label="分组名称">
      <el-input placeholder="多个名称可以用逗号分割" v-model="searchForm.names">
        <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(0)" />
      </el-input>
    </el-form-item>
    <el-form-item label="备注">
      <el-input v-model="searchForm.remarks" placeholder="多个可以用逗号分割">
        <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(2)" />
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
      <el-button @click="reset" icon="el-icon-refresh-right">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-button icon="el-icon-plus" @click="addNewGroup">新增顾客分组</el-button>
  </el-row>
  <el-table :data="list" style="margin-top: 1rem" border
            :header-cell-style="{background:'#eee',color:'black'}"
            max-height="600"
            ref="tableView"
  >
    <el-table-column v-for="(item, index) in listKeyMap"
                     :key="index"
                     :prop="item.key"
                     :label="item.title"
                     :width="item.width"
                     :fixed="item.flex"
                     v-if="item.type !== 3 && item.type !== 4 && item.type !== 5"
                     :type="item.typeText"
    >
    </el-table-column>
    <el-table-column v-for="(item, index) in listKeyMap"
                     :key="index"
                     :prop="item.key"
                     :label="item.title"
                     :width="item.width"
                     fixed="right"
                     v-if="item.type === 3"
                     :type="item.typeText"
    >
      <template slot-scope="scope">
        <el-button v-for="(actionItem, actionIndex) in item.actions" :key="'btn_' + actionIndex" size="mini" :type="actionItem.btnType" @click="btnAction(actionItem, scope.row)">
          {{actionItem.title}}
        </el-button>
      </template>
    </el-table-column>

  </el-table>
  <el-pagination style="margin-top: 1rem"
                 :page-size.sync="pageSize"
                 :total.sync="totalCount"
                 :current-page.sync="curPage"
                 @size-change="search"
                 @current-change="search"
                 :page-sizes="[20, 100, 200, 500, 1000]"
                 layout="total, sizes, prev, pager, next, jumper"
  />
  <el-dialog title="批量操作" :visible.sync="showMultipleEditBox">
    <el-card shadow="never" style="flex-wrap: wrap; justify-content: space-around">
      <el-tag v-for="(tag, index) in tags" :key="index" closable style="margin: 0.2rem">
        {{tag}}
      </el-tag>
      <el-input ref="multipleInput" style="margin: 0.2rem; width: 120px" size="small" v-model="multipleEditName" placeholder="新增-回车保存" @keyup.enter.native="change"/>
    </el-card>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="doneAction">确 定</el-button>
        <el-button @click="clearAction">清 除</el-button>
      </span>
  </el-dialog>
  <el-dialog :visible.sync="showEditGroup" :title="editGroupTitle" width="50%" :destroy-on-close="true">
    <add-or-edit-group :group-data="group" @success="customerAddOrEditSuccess" @close="closeAddOrEditCustomer"/>
  </el-dialog>
  <el-dialog :visible.sync="showMemberDialog" :title="group?group.name:''" width="80%" :destroy-on-close="true">
    <group-member :group-data="group"/>
  </el-dialog>
  <el-dialog :visible.sync="showAddMemberDialog" :title="'添加成员 (' + (group?group.name:'') + ')'" width="80%" height="80%" :destroy-on-close="true" @close="search">
    <add-group-member :group-data="group"/>
  </el-dialog>
</div>
</template>

<script>
import AddOrEditGroup from './addOrEditGroup'
import {queryGroup} from './groupApi'
import GroupMember from './groupMember'
import {operationByPath} from '../employee/employeeApi'
import AddGroupMember from './addGroupMember'
export default {
  name: 'group',
  components: {AddGroupMember, GroupMember, AddOrEditGroup},
  data () {
    return {
      searchForm: {
        names: '',
        remarks: ''
      },
      viewKey: -100000,
      searching: false,
      multipleEditBoxType: 0,
      tags: [],
      showMultipleEditBox: false,
      multipleEditName: '',
      showEditGroup: false,
      editGroupTitle: '新建分组',
      curPage: 1,
      totalCount: 0,
      totalPage: 0,
      pageSize: 20,
      list: [],
      listKeyMap: [],
      memberListKey: [],
      showMemberDialog: false,
      group: null,
      showAddMemberDialog: false
    }
  },
  created () {
    this.search()
  },
  methods: {
    search () {
      this.searching = true
      queryGroup(this.searchForm).then(rsp => {
        this.searching = false
        const {code, message, result} = rsp
        if (code === 0) {
          const { pagination, values } = result
          const { list, curPage, pageSize, totalCount, totalPage } = pagination
          this.curPage = curPage
          this.pageSize = pageSize
          this.totalPage = totalPage
          this.totalCount = totalCount
          this.list = list
          this.listKeyMap = values
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.searching = false
      })
    },
    addNewGroup () {
      this.group = {name: '', remark: ''}
      this.showEditGroup = true
    },
    deleteItems () {

    },
    addMore (type) {
      this.multipleEditBoxType = type
      const key = this.keyForType(type)
      if (key === null) {
        return
      }
      const tempArray = this.searchForm[key].split(',')
      for (let i = tempArray.length - 1; i >= 0; i--) {
        const tempText = tempArray[i].trim()
        if (tempText.length === 0) {
          tempArray.splice(i, 1)
        }
      }
      this.tags = tempArray
      this.showMultipleEditBox = true
      setTimeout(() => {
        this.$refs.multipleInput.focus()
      }, 100)
    },
    keyForType (type) {
      let key = null
      if (type === 0) {
        key = 'phones'
      } else if (type === 1) {
        key = 'names'
      } else if (type === 2) {
        key = 'contactPhones'
      } else if (type === 3) {
        key = 'contactNames'
      } else if (type === 4) {
        key = 'names'
      }
      return key
    },
    doneAction () {
      this.showMultipleEditBox = false
      const text = this.tags.join(',')
      const key = this.keyForType(this.multipleEditBoxType)
      this.searchForm[key] = text
    },
    clearAction () {
      this.tags = []
    },
    reset () {

    },
    change () {

    },
    customerAddOrEditSuccess () {
      this.showEditGroup = false
      this.search()
    },
    closeAddOrEditCustomer () {
      this.showEditGroup = false
      this.group = {}
    },
    btnAction (action, item) {
      const { type } = action
      if (type === 0) {
        const { code } = action
        if (code === 'edit') {
          this.group = item
          this.editCustomerTitle = '编辑分组信息'
          this.showEditGroup = true
        } else if (code === 'member') {
          this.group = item
          this.showMemberDialog = true
        } else if (code === 'add') {
          this.group = item
          this.showAddMemberDialog = true
        }
      } else if (type === 1) {
        const deleteAction = () => {
          let { actionLink } = action
          actionLink = this.replaceText(actionLink, item, true)
          operationByPath(actionLink).then(rsp => {
            const {code, message} = rsp
            if (code === 0) {
              this.search()
              this.$message.success('操作成功')
            } else {
              this.$message.error(message)
            }
          })
        }

        let { alertMsg } = action
        alertMsg = this.replaceText(alertMsg, item, false)
        this.$confirm(alertMsg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(deleteAction).catch(null)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customerGroup/group.vue